
import { eventBus } from '@/main'

const BREAKPOINTS_DEFAULTS = {
  thresholds: {
    xxs: 384,
    xs: 768,
    sm: 935,
    md: 1200,
    lg: 1920
  },
  scrollbarWidth: 16
}
/**
 * Работа с разрешением экрана
 * @mixin
 * @alias display-size
 * @vue-data {Numeric} clientWidth - Текущая ширина экрана
 * @vue-data {Numeric} clientHeight - Текущая высота экрана
 * @vue-computed {Object} breakpoint - Объект с текущими параметрами экрана
 */
export default {
  data() {
    return {
      clientWidth: this.getClientWidth(),
      clientHeight: this.getClientHeight(),
      landscape: this.checkLandscape(),
      hasScroll: false,
      verticalScroll: document.documentElement.scrollHeight > document.documentElement.clientHeight,
      horisontalScroll: document.documentElement.scrollWidth > document.documentElement.clientWidth,
      ...BREAKPOINTS_DEFAULTS,
    }
  },
  created() {
    if (typeof window === 'undefined') { return }
    if (this.$root && this.$root.$eventBus) {
      this.$root.$eventBus.$on('resizeWindow', this.setDimensions)
    } else if (typeof eventBus !== 'undefined') {
      eventBus.$on('resizeWindow', this.setDimensions)
    }
  },
  beforeDestroy() {
    if (typeof window === 'undefined') { return }
    if (this.$root && this.$root.$eventBus) {
      this.$root.$eventBus.$off('resizeWindow', this.setDimensions)
    } else if (typeof eventBus !== 'undefined') {
      eventBus.$off('resizeWindow', this.setDimensions)
    }
  },
  methods: {
    /**
    * Получить ширину экрана
    * @return {Numeric} Ширина экрана
    */
    getClientWidth() {
      if (typeof document === 'undefined') { return 0 }
      return Math.max(
        (document.documentElement !== undefined ? document.documentElement.clientWidth : 0),
        window.innerWidth || 0
      )
    },
    /**
    * Получить высоту экрана
    * @return {Numeric} Высоту экрана
    */
    getClientHeight() {
      if (typeof document === 'undefined') { return 0 }
      return Math.max(
        (document.documentElement !== undefined ? document.documentElement.clientHeight : 0),
        window.innerHeight || 0
      )
    },
    checkLandscape() {
      if (!window) {
        return false
      }
      if (!window.screen || !window.screen.orientation) {
        if (window.orientation) {
          return window.orientation === 180 || window.orientation === 90
        }
        return false
      }
      return window.screen.orientation.type === 'landscape-primary'
    },
    /**
    * Заполнитить данные data
    */
    setDimensions() {
      this.hasScroll = document.documentElement.scrollHeight > document.documentElement.clientHeight
      this.clientHeight = this.getClientHeight()
      this.clientWidth = this.getClientWidth()
      this.landscape = this.checkLandscape()
    }
  },
  computed: {
    breakpoint() {
      const xxs = this.clientWidth < this.thresholds.xxs
      const xs = this.clientWidth < this.thresholds.xs && !xxs
      const sm = this.clientWidth < this.thresholds.sm && !(xs || xxs)
      const md = this.clientWidth < (this.thresholds.md - this.scrollbarWidth) && !(sm || xs || xxs)
      const lg = this.clientWidth < (this.thresholds.lg - this.scrollbarWidth) && !(md || sm || xs || xxs)
      const xl = this.clientWidth >= (this.thresholds.lg - this.scrollbarWidth)

      const xsAndDown = (xxs || xs) && !(sm || md || lg || xl)
      const xsAndUp = !xxs && (xs || sm || md || lg || xl)
      const smAndDown = (xxs || xs || sm) && !(md || lg || xl)
      const smAndUp = !(xxs || xs) && (sm || md || lg || xl)
      const mdAndDown = (xxs || xs || sm || md) && !(lg || xl)
      const mdAndUp = !(xxs || xs || sm) && (md || lg || xl)
      const lgAndDown = (xxs || xs || sm || md || lg) && !xl
      const lgAndUp = !(xxs || xs || sm || md) && (lg || xl)

      let name
      switch (true) {
      case (xxs):
        name = 'xxs'
        break
      case (xs):
        name = 'xs'
        break
      case (sm):
        name = 'sm'
        break
      case (md):
        name = 'md'
        break
      case (lg):
        name = 'lg'
        break
      default:
        name = 'xl'
        break
      }

      return {
        name,
        landscape: this.landscape,
        xxs,
        xs,
        sm,
        md,
        lg,
        xl,
        xsAndDown,
        xsAndUp,
        smAndDown,
        smAndUp,
        mdAndDown,
        mdAndUp,
        lgAndDown,
        lgAndUp,

        width: this.clientWidth,
        height: this.clientHeight,
        thresholds: this.thresholds,
        scrollbarWidth: this.scrollbarWidth
      }
    }
  },
}
